import { useSessionClaims } from './use-session-claims';

/**
 * Hook to check if the current user has superadmin privileges.
 *
 * Reads from the Clerk session-token `tgdRoles` claim — no network
 * request. publicMetadata.tgdRoles is the single source of truth and
 * is promoted to the session token via the Clerk Dashboard JWT
 * customization. Every active session has rolled over to this path
 * since the 2026-05 cleanup; the legacy `getCurrentUserInfo` fallback
 * (which hit tRPC when claims were empty) was removed once the
 * dual-write to privateMetadata.tgdRoles was wiped from Clerk.
 */
export function useSuperAdmin() {
    const { isSuperAdmin, isLoaded } = useSessionClaims();
    return {
        isSuperAdmin,
        isLoading: !isLoaded,
    };
}
